import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Informes/imprimirInformeProductividadExtraccionesVerraco`, method: 'POST', body: list, token: token})
}